

























































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import Pagination from '@morpheus/utils/admin-vue/mixins/pagination'
import ConfigList from '../components/ConfigList.vue'
import { deleteConfigById, fetchConfigsList, updateConfig } from '../services/config-client'
import { ConfigListData, ConfigShowData } from '../types'

export default mixins(Pagination).extend({
  name: 'Config',
  components: {
    ConfigList
  },
  data () {
    return {
      isLoading: true,
      search: {
        query: ''
      },
      headers: [
        { text: 'Key', value: 'key', sortable: false },
        { text: 'Value', value: 'value', sortable: false },
        { text: 'Enabled', value: 'enabled', sortable: false },
        { text: 'Created At', value: 'created_at', sortable: false },
        { text: 'Updated At', value: 'updated_at', sortable: false },
        { text: 'Actions', value: '_id', align: 'center', sortable: false }
      ],
      itemsList: []
    }
  },
  mounted () {
    this.$store.commit('global/setLoading', true)
    this.fetchItems()
  },
  methods: {
    fetchItems () {
      this.isLoading = true
      fetchConfigsList(`?limit=${this.rowsPerPage}&offset=${this.paginationOffset}`)
        .then(({ items, total }: ConfigListData) => {
          this.itemsList.splice(0, this.itemsTotal)
          items.forEach((item: ConfigShowData, index: number) => {
            Vue.set(this.itemsList, index, item)
          })
          this.itemsTotal = total
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.checkPagination()
          this.isLoading = false
          this.$store.commit('global/setLoading', false)
        })
    },
    onDeleteConfig (id: string) {
      this.isLoading = true
      deleteConfigById(id)
        .then(() => {
          this.fetchItems()
          this.$store.commit('global/addNotification', { text: 'You successfully deleted config!', type: 'success' })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    onChangeStatus  (status: boolean, id: string) {
      this.isLoading = true
      updateConfig({ enabled: status }, id)
        .then(() => {
          this.fetchItems()
          this.$store.commit('global/addNotification', {
            text: 'You successfully changed config status!',
            type: 'success'
          })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
})
